/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UserSignature {
  /**
   * Signature data (base64 encoded)
   */
  data?: string | null;
  /**
   * Signature data mime type
   */
  mime_type?: string | null;
}
